module.exports = "/_next/static/images/10bf1cebb9daac1228fade9dfa75ff87-notaxes@2x.jpg";